import * as React from "react";
import { RegistrationUser, ApiResponse } from "./types";
import { getData } from "lib/api/apiService";
import apiService from "lib/api/apiService";
import Cookies from "js-cookie";

export const usePrizePicksProjections = () => {
  const [projections, setProjections] = React.useState<ApiResponse | null>(null);
  const [projectionError, setProjectionError] = React.useState("");
  const [loading, setLoading] = React.useState(true);


const fetchProjectionsData = React.useCallback(async () => {
    try {
      const token = Cookies.get('token');

      if (token) {
        const response = await getData(token);
        setProjections(response);
        setLoading(false);
      } else {
        // Handle the case when the token is missing or invalid
        console.error("Token is missing or invalid");
      }
    } catch (error) {
      setProjectionError("Failed to fetch data.");
    }
  }, []);

  React.useEffect(() => {
    fetchProjectionsData();
  }, [fetchProjectionsData]);

  return { projections, loading, projectionError, fetchProjectionsData };
};
